import styled from 'styled-components';
import device from '../../../styles/mediaSizes';

export const StyledExpertsCTO = styled.div`
  .rn-section-gap {
    padding: 240px 0 !important;
    @media ${device.lg} {
      padding: 200px 0 !important;
    }
    @media ${device.md} {
      padding: 150px 0 !important;
    }
    @media ${device.sm} {
      padding: 80px 0 !important;
    }
  }

  .decor-relative-anchor {
    position: relative;
    border-bottom: 6px solid #73d45f;

    .decor-images-wrapper-1 {
      .decor-image-1 {
        position: absolute;
        z-index: 1;
        left: 0;
        top: -50px;
        right: 0;
        width: 90%;
        max-width: 600px;
        margin-right: auto;
        margin-left: auto;
        -o-object-fit: fill;
        object-fit: fill;
      }
      .decor-image-2 {
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        width: 100%;
        max-width: 1000px;
        margin-top: -20px;
        margin-right: auto;
        margin-left: auto;
      }
    }
    .decor-images-wrapper-2 {
      .decor-image-1 {
        position: absolute;
        z-index: 1;
        left: 0;
        bottom: 0;
        transform: translate(0, 30%);
        right: 0;
        width: 98%;
        margin-right: auto;
        margin-left: auto;
        -o-object-fit: fill;
        object-fit: fill;
      }
      .decor-image-2 {
        position: absolute;
        z-index: 0;
        left: 0;
        bottom: 0;
        right: 0;
        width: 100%;
        margin-right: auto;
        margin-left: auto;
        -o-object-fit: fill;
        object-fit: fill;
      }
    }
    @media ${device.lg} {
    }
    @media ${device.md} {
      & {
        position: relative;
        border-bottom: 6px solid #73d45f;

        .decor-images-wrapper-1 {
          .decor-image-1 {
            position: absolute;
            z-index: 1;
            left: 0;
            top: -50px;
            right: 0;
            width: 90%;
            max-width: 480px;
            margin-right: auto;
            margin-left: auto;
            -o-object-fit: fill;
            object-fit: fill;
          }
          .decor-image-2 {
            position: absolute;
            left: 0;
            top: 0;
            right: 0;
            width: 100%;
            max-width: 1000px;
            margin-top: -20px;
            margin-right: auto;
            margin-left: auto;
          }
        }
        .decor-images-wrapper-2 {
          .decor-image-1 {
            position: absolute;
            z-index: 1;
            left: 0;
            bottom: 0;
            transform: translate(0, 30%);
            right: 0;
            width: 98%;
            margin-right: auto;
            margin-left: auto;
            -o-object-fit: fill;
            object-fit: fill;
          }
          .decor-image-2 {
            position: absolute;
            z-index: 0;
            left: 0;
            bottom: 0;
            right: 0;
            width: 100%;
            margin-right: auto;
            margin-left: auto;
            -o-object-fit: fill;
            object-fit: fill;
          }
        }
      }
    }
    @media ${device.sm} {
      & {
        position: relative;
        border-bottom: 6px solid #73d45f;
        .decor-images-wrapper-1 {
          .decor-image-1 {
            position: absolute;
            z-index: 1;
            left: 0;
            top: -30px;
            right: 0;
            width: 90%;
            max-width: 250px;
            margin-right: auto;
            margin-left: auto;
            -o-object-fit: fill;
            object-fit: fill;
          }
          .decor-image-2 {
            position: absolute;
            left: 0;
            top: 0;
            right: 0;
            width: 100%;
            max-width: 200px;
            margin-top: 0;
            margin-right: auto;
            margin-left: auto;
          }
        }
        .decor-images-wrapper-2 {
          .decor-image-1 {
            position: absolute;
            z-index: 1;
            left: 0;
            bottom: 0;
            transform: translate(0, 40%);
            right: 0;
            width: 98%;
            margin-right: auto;
            margin-left: auto;
            -o-object-fit: fill;
            object-fit: fill;
          }
          .decor-image-2 {
            position: absolute;
            z-index: 0;
            left: 0;
            bottom: 0;
            right: 0;
            width: 100%;
            margin-right: auto;
            margin-left: auto;
            -o-object-fit: fill;
            object-fit: fill;
          }
        }
      }
    }
  }

  .section-title-wrapper {
    width: 800px;
    margin: auto;
    margin-bottom: 40px;
    .title {
      text-align: center;
      margin-bottom: 15px;
    }
    .subtitle {
      text-align: center;
    }
    .description {
      margin: 0 auto;
      text-align: center;
      width: 80%;
    }

    @media ${device.lg} {
      & {
        margin-bottom: 75px;
        .title {
          font-size: 55px;
          line-height: 80px;
          text-align: center;
          margin-bottom: 20px;
        }
        .subtitle {
          text-align: center;
        }
        .description {
          margin: 0 auto;
          text-align: center;
          width: 80%;
        }
      }
    }
    @media ${device.md} {
      & {
        width: 500px;
        margin-bottom: 55px;
        .title {
          font-size: 42px;
          line-height: 60px;
          text-align: center;
          margin-bottom: 20px;
        }
        .subtitle {
        }
        .description {
          width: 100%;
        }
      }
    }
    @media ${device.sm} {
      & {
        width: 300px;
        margin-bottom: 55px;
        .title {
          font-size: 28px;
          line-height: 35px;
          text-align: center;
          margin-bottom: 20px;
        }
        .subtitle {
        }
        .description {
          width: 100%;
        }
      }
    }
  }

  .text-button {
    display: block;
    margin: 0 auto;
    text-align: center;
  }
`;
